import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  AbstractAppConfigService,
  APP_CONFIG_SERVICE,
  IHttpBasicResponse,
  IHttpBasicResponseEcwid,
  IHttpBasicResponseImageEcwid,
  IHttpBasicResponseStore,
} from '@boxx/core';
import {
  ICategoryApiModel,
  ICategoryImageUploadApiModel,
  ICreateOrderPayload,
  ICreateVariationPayload,
  IImageApiModel,
  IOrderApiModel,
  IProductApiModel,
  IProfileApiModel,
  IUpdateStatusOrderPayload,
  IVariationApiModel,
} from './IStore.api';
import { IStoreRepository } from './IStore.repository';
import { EcwidModel } from '../models/Ecwid.model';
import { IProductImageUpload } from '../models/Product.model';
import { StoreProfileModel } from '../models/Store.model';
import { IPixabayImages } from '@boxx/boxx-images/lib/contracts/IImages';

@Injectable()
export class StoreRepository implements IStoreRepository {
  constructor(
    @Inject(APP_CONFIG_SERVICE) private appSettings: AbstractAppConfigService,
    private httpClient: HttpClient
  ) {}

  // --------------------- CATEGORIES: -------------------------
  loadCategories(
  ): Observable<IHttpBasicResponseEcwid<ICategoryApiModel[]>> {
    return this.httpClient.get<IHttpBasicResponseEcwid<ICategoryApiModel[]>>(
      `${this.getBaseUrlEcwid()}/ecwid/categories`
    );
  }

  loadCategoryById(
    id: number
  ): Observable<IHttpBasicResponse<ICategoryApiModel>> {
    return this.httpClient.get<IHttpBasicResponse<ICategoryApiModel>>(
      `${this.getBaseUrl()}/categories/${id}`
    );
  }
  getSingleCategory(
    id: number
  ): Observable<IHttpBasicResponseImageEcwid<ICategoryImageUploadApiModel>> {
    return this.httpClient.get<IHttpBasicResponseImageEcwid<ICategoryImageUploadApiModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/category/${id}`
    );
  }

  createCategory(
    payload: any
  ): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/add_category`,
      payload
    );
  }

  // createCategory(payload: any): Promise<any> {

  //   return new Promise((resolve) => {
  //     const promises: Promise<any>[] = [];

  //         promises.push(
  //           new Promise((resolve, reject) => {
  //             this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
  //               `${this.getBaseUrlEcwid()}/ecwid//add_category`,
  //               payload
  //             ).subscribe(
  //               (cat) => {
  //                 if(payload.image){

  //                   const urlSearchParams = new URLSearchParams();
  //                   urlSearchParams.append('file', payload.image);
  //                   const body = urlSearchParams.toString();

  //                   new Promise((resolve, reject) => {
  //                     this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
  //                       `${this.getBaseUrlEcwid()}/ecwid//image_category/${cat.data.id}`,
  //                       body
  //                     ).subscribe(
  //                       (response) => {
  //                         resolve(response);
  //                       },
  //                       (error) => reject(error)
  //                     );
  //                   })
  //                 }
  //                 else{
  //                   resolve(cat);
  //                 }                  
  //               },
  //               (error) => reject(error)
  //             );
  //           })
  //         );
  //   });

  // }

  updateCategory(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/update_category/${payload.id}`,
      payload
    );
  }

  deleteCategory(id: number): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/delete_category/${id}`
    );
  }

  uploadImageCategory(id: number, fileBase: string): Observable<IHttpBasicResponse<any>> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('file', fileBase);
    const body = urlSearchParams.toString();

    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/image_category/${id}`,
      body
    );
  }

  deleteImageCategory(id: number): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/delete_image_category/${id}`
    );
  }

  searchImages(params: any): Observable<IHttpBasicResponse<IPixabayImages>> {
    var headers = new HttpHeaders()
     headers.append('Content-Type', 'application/x-www-form-urlencoded');
    const urlSearchParams = new URLSearchParams();
    Object.keys(params).forEach((key: string) => {
      urlSearchParams.append(key, params[key]);
    });

    const body = urlSearchParams.toString();
    return this.httpClient.post<IHttpBasicResponse<IPixabayImages>>(
      `${this.getBaseUrlPixaBay()}/api/json/v1/builder/getPixInfo`,  
      body, { headers } 
    );
  }

  // --------------------- ORDERS: -------------------------
  loadOrders(): Observable<IHttpBasicResponseEcwid<IOrderApiModel[]>> {
    console.warn('--- StoreRepositoryMock::loadOrders()');
    return this.httpClient.get<IHttpBasicResponseEcwid<IOrderApiModel[]>>(
      `${this.getBaseUrlEcwid()}/ecwid/orders`
    );
  }

  loadOrderById(id: string): Observable<IHttpBasicResponse<IOrderApiModel>> {
    return this.httpClient.get<IHttpBasicResponse<IOrderApiModel>>(
      `${this.getBaseUrl()}/ecwid/orders/${id}`
    );
  }

  updateOrder(
    payload: IUpdateStatusOrderPayload
  ): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/update_order/${payload.id}`,
      payload
    );
  }

  createOrder(
    payload: ICreateOrderPayload
  ): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/create_order`,
      payload
    );
  }

  deleteOrder(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/delete_order/${payload}`
    );
  }

  // --------------------- PRODUCTS: -------------------------

  loadProducts(
    ): Observable<IHttpBasicResponseEcwid<IProductApiModel[]>> {
      return this.httpClient.get<IHttpBasicResponseEcwid<IProductApiModel[]>>(
        `${this.getBaseUrlEcwid()}/ecwid/products`
      );
    }
    createProduct(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/add_product`,
        payload
      );
    }
    updateProduct(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/update_product/${payload.id}`,
        payload
      );
    }

    deleteProduct(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/delete_product/${payload}`
      );
    }

    getSingleProduct(
      id: number
    ): Observable<IHttpBasicResponseImageEcwid<IProductApiModel>> {
      return this.httpClient.get<IHttpBasicResponseImageEcwid<IProductApiModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/single_product/${id}`
      );
    }


  loadProductById(
    id: number
  ): Observable<IHttpBasicResponse<IProductApiModel>> {
    return this.httpClient.get<IHttpBasicResponse<IProductApiModel>>(
      `${this.getBaseUrl()}/products/${id}`
    );
  }

  uploadImageProduct(payload: IProductImageUpload): Observable<IHttpBasicResponse<any>> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('file', payload.file);
    if(payload.gallery){      
      urlSearchParams.append('gallery', payload.gallery.toString());
    }
    const body = urlSearchParams.toString();

    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/add_image_product/${payload.id}`,
      body
    );
  }
  deleteImageProduct(payload: any): Observable<IHttpBasicResponse<null>> {
    if(payload.type == 1){
      return this.httpClient.delete<IHttpBasicResponse<null>>(
        `${this.getBaseUrlEcwid()}/ecwid/delete_main_picture/${payload.id}`
      );
    }
    else {
      return this.httpClient.delete<IHttpBasicResponse<null>>(
        `${this.getBaseUrlEcwid()}/ecwid/delete_picture/${payload.id}/${payload.index}`
      );
    }
  }

  // ---------------- PRODUCT VARIATIONS: ---------------------
  loadProductsVariations(
    pagination = ''
  ): Observable<IHttpBasicResponse<IVariationApiModel[]>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/product_variations${pagination}`
    );
  }
  loadProductVariationByVariationId(
    id: number
  ): Observable<IHttpBasicResponse<IVariationApiModel>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/product_variations/${id}`
    );
  }
  createProductVariation(
    payload: ICreateVariationPayload
  ): Observable<IHttpBasicResponse<IVariationApiModel>> {
    const body = this.createHttParams(payload);
    return this.httpClient.post<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/create_product_variation`,
      body
    );
  }
  deleteProductVariation(id: number): Observable<IHttpBasicResponse<null>> {
    return this.httpClient.delete<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/delete_product_variation/${id}`
    );
  }

  // --------------------- IMAGES: -------------------------
  loadSiteImages(
    pagination = ''
  ): Observable<IHttpBasicResponse<IImageApiModel[]>> {
    return this.httpClient.get<IHttpBasicResponse<any[]>>(
      `${this.getBaseUrl()}/site_images${pagination}`
    );
  }
  loadSiteImageById(
    id: number
  ): Observable<IHttpBasicResponse<IImageApiModel>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/site_images/${id}`
    );
  }
  createSiteImage(
    payload: number
  ): Observable<IHttpBasicResponse<IImageApiModel>> {
    const body = this.createHttParams(payload);
    return this.httpClient.post<IHttpBasicResponse<IImageApiModel>>(
      `${this.getBaseUrl()}/create_site_image`,
      body
    );
  }
  deleteSiteImage(id: number): Observable<IHttpBasicResponse<null>> {
    return this.httpClient.delete<IHttpBasicResponse<any>>(
      `${this.getBaseUrl()}/delete_site_image/${id}`
    );
  }

  createHttParams(payload: any) {
    let params = new HttpParams();
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        if (typeof payload[key] === 'object') {
          params = params.append(key, JSON.stringify(payload[key]));
        } else {
          params = params.append(key, payload[key]);
        }
      }
    }

    return params.toString();
  }

    // --------------------- ECWID: -------------------------
    getLinkValidation(): Observable<IHttpBasicResponse<EcwidModel>> {
      return this.httpClient.get<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/get_link`
      );
    }
    
    getLinkSSO(): Observable<IHttpBasicResponse<EcwidModel>> {
      return this.httpClient.get<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/sso`
      );
  }
   
  openSSOHidden(url: string): Observable<IHttpBasicResponse<EcwidModel>> {
    return this.httpClient.get<IHttpBasicResponse<EcwidModel>>(
      `${url}`
    );
  }

  getToken(
    bId: number, businessId: number
  ): Observable<IHttpBasicResponse<EcwidModel>> {
    const body = null;
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/Oauthwid/update/${bId}/${businessId}`,
      body
    );
  }
  
  getProfile(): Observable<IHttpBasicResponseStore<StoreProfileModel>> {
    const body = null;
    return this.httpClient.post<IHttpBasicResponseStore<StoreProfileModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/profile`,
      body
    );
  }

  updateProfile(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<IProfileApiModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/profile_update`,
      payload
    );
  }

  uploadImageProfile(fileBase: string): Observable<IHttpBasicResponse<any>> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('file', fileBase);
    const body = urlSearchParams.toString();

    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/add_profile_logo`,
      body
    );
  }    
  
  deleteImageProfile(_payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `${this.getBaseUrlEcwid()}/ecwid/delete_logo`
    );
  }
  private getBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/${this.appSettings.instance()}/v1/shop`;
  }

  private getBaseUrlPixaBay() {
    return `${this.appSettings.baseUrl()}/`;
  }

  private getBaseUrlEcwid() {
    return `${this.appSettings.baseUrl()}/api/json/v1`;
  }


  // --------------------- COUPONS: -------------------------

  loadCoupons(
    ): Observable<IHttpBasicResponseEcwid<any[]>> {
      return this.httpClient.get<IHttpBasicResponseEcwid<any[]>>(
        `${this.getBaseUrlEcwid()}/ecwid/coupons`
      );
    }
  
  createCoupon(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/add_coupon`,
        payload
      );
  }

  updateCoupon(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/update_coupon/${payload.id}`,
        payload
      );
  }

  deleteCoupon(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
        `${this.getBaseUrlEcwid()}/ecwid/delete_coupon/${payload}`
      );
  }

  getSingleCoupon(
      id: number
    ): Observable<IHttpBasicResponseImageEcwid<any>> {
      return this.httpClient.get<IHttpBasicResponseImageEcwid<any>>(
        `${this.getBaseUrlEcwid()}/ecwid/coupon/${id}`
      );
  }

}
